// eslint-disable-next-line eslint-js/no-restricted-imports
import styled from "@emotion/styled";

export const FullContainer = styled.div`
  width: 100%;
  height: 100%;
`;
